import { mapURL } from '../constants';
import {titleCase} from './titleCase';

export function dealerExtendAddress(dealer) {
    let mapLinkAddress = dealer.address.replace('\n', '<br />'),
		htmlAddress = titleCase(mapLinkAddress),
		{ city, state, country, isInternational, zip } = dealer;
	if (city && city !== '') {
		mapLinkAddress += ', ' + city;
		htmlAddress += '<br>' + titleCase(city);
	}
	if (state && state !== '') {
		mapLinkAddress += ', ' + state;
		htmlAddress += ', ' + titleCase(state);
	}
	if (country && country !== '' && isInternational) {
		mapLinkAddress += ', ' + country;
		htmlAddress += ', ' + country;
	}
	if (zip && zip !== '') {
		mapLinkAddress += ' ' + zip;
		htmlAddress += ' ' + zip;
	}

	mapLinkAddress = `${mapLinkAddress}, ${city}, ${state}, ${country} ${zip}`;
	mapLinkAddress = `${mapLinkAddress}<br> ${city}, ${state}, ${country} ${zip}`;

	let mapLink = mapURL + encodeURIComponent(mapLinkAddress);

	return {...dealer, mapLink, htmlAddress};
}